<template>
  <div v-if="closedAt !== updatedAt" class="flex fixed mt-10 z-30 justify-center w-full px-14 md:px-0">
    <div class="container flex items-start justify-center w-fit px-20 bg-lightest-orange-2 border border-light-orange rounded-10 shadow-md">
      <div
        class="font-bold text-orange leading-1.25 text-12 lg:text-16 lg:leading-1.2 py-12"
      >
        <slot></slot>
      </div>
      <button
        class="h-full p-6 ml-6 text-orange focus:outline-none"
        @click="closedAt = updatedAt"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
const KEY = "updatedAt";

export default {
  props: {
    updatedAt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      closedAt: window.localStorage.getItem(KEY),
    };
  },

  watch: {
    closedAt() {
      window.localStorage.setItem(KEY, this.updatedAt);
    },
  },
};
</script>
